/**
 * Quick Buy Quantity Button Handlers
 * Disables minus button when quantity is 1
 */
(function() {
  let inlineHandlersInitialized = false;
  const inFlightVariants = new Set();
  const cartCache = {
    data: null,
    fetchedAt: 0,
    inFlight: null,
  };
  const CART_CACHE_TTL = 3000;
  let toastTimer = null;

  function updateCartBubble(cart) {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink || !cart) return;

    const count =
      typeof window.getCartQuantityForHeaderBubble === 'function'
        ? window.getCartQuantityForHeaderBubble(cart)
        : cart.item_count || 0;
    let bubble = cartLink.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        cartLink.appendChild(bubble);
      }

      const countText = String(count);
      bubble.innerHTML = `
        <span aria-hidden="true">${countText}</span>
        <span class="visually-hidden">Cart (${count})</span>
      `;
    } else if (bubble) {
      bubble.remove();
    }
  }

  function getCartState(options = {}) {
    const now = Date.now();
    const forceFresh = options && options.forceFresh === true;
    if (!forceFresh && cartCache.data && now - cartCache.fetchedAt < CART_CACHE_TTL) {
      return Promise.resolve(cartCache.data);
    }
    if (!forceFresh && cartCache.inFlight) return cartCache.inFlight;

    cartCache.inFlight = fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((data) => {
        cartCache.data = data;
        cartCache.fetchedAt = Date.now();
        return data;
      })
      .catch(() => null)
      .finally(() => {
        cartCache.inFlight = null;
      });

    return cartCache.inFlight;
  }

  function setCartCache(cartData) {
    if (!cartData) return;
    cartCache.data = cartData;
    cartCache.fetchedAt = Date.now();
  }

  function getRowContext(button) {
    const row = button.closest('tr.qb-row');
    const qtyInput = row ? row.querySelector('.qb-quantity-input') : null;
    const variantId =
      button.getAttribute('data-variant-id') ||
      (row ? row.getAttribute('data-variant-id') : null) ||
      (row && row.dataset ? row.dataset.variantId : null);
    const availableAttr =
      (qtyInput && qtyInput.getAttribute('data-available-qty')) ||
      (row ? row.getAttribute('data-available-qty') : null) ||
      (row && row.dataset ? row.dataset.availableQty : null);
    const availableQty = availableAttr ? parseInt(availableAttr, 10) : null;
    const requestedQty = qtyInput ? parseInt(qtyInput.value, 10) : 0;

    return {
      variantId,
      availableQty: Number.isNaN(availableQty) ? null : availableQty,
      requestedQty: Number.isNaN(requestedQty) ? 0 : requestedQty,
      rowEl: row,
      qtyInput,
    };
  }

  function getInCartQty(cart, variantId) {
    if (!cart || !cart.items || !variantId) return 0;
    const match = cart.items.find((item) => String(item.id) === String(variantId));
    return match ? match.quantity : 0;
  }

  function getToastHost() {
    return document.querySelector('.quick-buy-content') || document.body;
  }

  function getToastElement() {
    const host = getToastHost();
    if (!host) return null;
    let toast = host.querySelector('.qb-stock-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'qb-stock-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.setAttribute('aria-atomic', 'true');
      host.appendChild(toast);
    }
    return toast;
  }

  function showStockToast(message) {
    const toast = getToastElement();
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 3000);
  }

  function updateInlineQuantityStates() {
    const rows = document.querySelectorAll('table.qb-product-table tbody tr.qb-row');
    rows.forEach((row) => {
      const qtyInput = row.querySelector('.qb-quantity-input');
      const minusBtn = row.querySelector('.qb-quantity-btn[data-action="decrement"]');
      if (!qtyInput || !minusBtn) return;

      const currentValue = parseInt(qtyInput.value, 10) || 1;
      if (currentValue <= 1) {
        minusBtn.disabled = true;
      } else {
        minusBtn.disabled = false;
      }
    });
  }

  function normalizeQuantity(rawValue, options = {}) {
    const min = Number.isFinite(options.min) ? options.min : 1;
    const hasMax = options.max !== null && options.max !== undefined && !Number.isNaN(options.max);
    const max = hasMax ? options.max : null;
    let value = parseInt(rawValue, 10);
    if (Number.isNaN(value)) value = min;
    if (value < min) value = min;
    if (max !== null && value > max) value = max;
    return value;
  }

  function clampInlineQuantity(input) {
    const min = parseInt(input.getAttribute('min'), 10) || 1;
    const availableAttr = input.getAttribute('data-available-qty');
    const maxAttr = input.getAttribute('max');
    const max = availableAttr ? parseInt(availableAttr, 10) : maxAttr ? parseInt(maxAttr, 10) : null;
    const value = normalizeQuantity(input.value, { min, max });
    input.value = String(value);
    return value;
  }

  function initInlineHandlers() {
    if (inlineHandlersInitialized) return;
    inlineHandlersInitialized = true;

    // Plus/Minus für Order Qty wird nur in quick-buy-quantity-handlers.js behandelt (vermeidet Doppelklick = Schritt 2)
    // Inline Add-to-Cart ebenfalls nur dort.

    document.addEventListener('input', (e) => {
      const input = e.target.closest('.qb-quantity-input');
      if (!input) return;
      clampInlineQuantity(input);
      updateInlineQuantityStates();
    });
  }


  /**
   * Additive add-to-cart (kept for consistency if ever called from another path).
   * Inline button on stockorder is handled only by quick-buy-quantity-handlers.js.
   */
  function handleInlineAddToCart(button) {
    const context = getRowContext(button);
    const variantId = context.variantId;
    if (!variantId) return;

    if (inFlightVariants.has(String(variantId))) return;
    inFlightVariants.add(String(variantId));

    const availableQty = context.availableQty;
    const selectedQty = normalizeQuantity(context.requestedQty, { min: 1, max: availableQty });
    if (context.qtyInput) context.qtyInput.value = String(selectedQty);
    if (!selectedQty || selectedQty <= 0) {
      inFlightVariants.delete(String(variantId));
      return;
    }

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const config = window.fetchConfig ? fetchConfig('javascript') : { method: 'POST', headers: { 'Accept': 'application/json' } };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const finalizeUpdate = (cartData) => {
      if (cartData) {
        setCartCache(cartData);
        updateCartBubble(cartData);
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'quick-buy',
            productVariantId: variantId,
            cartData: cartData || null,
          });
        }
      }
    };

    const proceedAdd = (quantityToAdd) => {
      if (!quantityToAdd || quantityToAdd <= 0) {
        inFlightVariants.delete(String(variantId));
        return;
      }
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantityToAdd);
      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
      }
      config.body = formData;
      button.disabled = true;
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'quick-buy',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
            }
            getCartState({ forceFresh: true }).then(finalizeUpdate);
            return;
          }
          if (!cart) {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (typeof cart.renderContents === 'function') cart.renderContents(response);
          getCartState({ forceFresh: true }).then(finalizeUpdate);
        })
        .catch(() => {})
        .finally(() => {
          button.disabled = false;
          inFlightVariants.delete(String(variantId));
        });
    };

    const proceedChange = (lineItemKey, targetQty) => {
      if (!lineItemKey || targetQty < 0) {
        inFlightVariants.delete(String(variantId));
        return;
      }
      const formData = new FormData();
      formData.append('id', lineItemKey);
      formData.append('quantity', targetQty);
      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
      }
      config.body = formData;
      button.disabled = true;
      fetch('/cart/change.js', config)
        .then((response) => response.json())
        .then((cartData) => finalizeUpdate(cartData))
        .catch(() => {})
        .finally(() => {
          button.disabled = false;
          inFlightVariants.delete(String(variantId));
        });
    };

    getCartState({ forceFresh: true })
      .then((cartData) => {
        // CHANGE: Handle null cartData gracefully - treat as empty cart
        if (!cartData || !Array.isArray(cartData.items)) {
          // If cart fetch failed, proceed with add (assume item not in cart)
          const availableQty = context.availableQty;
          const qtyToAdd = availableQty !== null && !Number.isNaN(availableQty) && availableQty > 0
            ? Math.min(selectedQty, availableQty) 
            : selectedQty;
          if (qtyToAdd > 0) {
            proceedAdd(qtyToAdd);
          } else {
            inFlightVariants.delete(String(variantId));
            button.disabled = false;
          }
          return;
        }

        const cartItem = cartData.items.find((item) => String(item.id) === String(variantId)) || null;
        const existingQty = cartItem ? cartItem.quantity : 0;
        let targetQty = existingQty + selectedQty;

        // CHANGE: Stock-limit validation - clamp targetQty to availableQty if limit exists
        const availableQty = context.availableQty;
        if (availableQty !== null && !Number.isNaN(availableQty) && availableQty > 0) {
          if (targetQty > availableQty) {
            targetQty = availableQty;
          }
          // If already at or above limit, don't proceed
          if (existingQty >= availableQty) {
            inFlightVariants.delete(String(variantId));
            button.disabled = false;
            return;
          }
        }

        if (!cartItem) {
          // CHANGE: For new items, ensure we don't add more than available
          const qtyToAdd = availableQty !== null && !Number.isNaN(availableQty) && availableQty > 0
            ? Math.min(selectedQty, availableQty) 
            : selectedQty;
          if (qtyToAdd <= 0) {
            inFlightVariants.delete(String(variantId));
            button.disabled = false;
            return;
          }
          proceedAdd(qtyToAdd);
          return;
        }
        proceedChange(cartItem.key, targetQty);
      })
      .catch((error) => {
        // CHANGE: On error, fallback to direct add (assume item not in cart)
        const availableQty = context.availableQty;
        const qtyToAdd = availableQty !== null && !Number.isNaN(availableQty) && availableQty > 0
          ? Math.min(selectedQty, availableQty) 
          : selectedQty;
        if (qtyToAdd > 0) {
          proceedAdd(qtyToAdd);
        } else {
          inFlightVariants.delete(String(variantId));
          button.disabled = false;
        }
      });
  }

  function initQuantityButtonStates() {
    setTimeout(() => {
      const rows = document.querySelectorAll('table.qb-product-table tbody tr.qb-row');
      if (rows.length > 0) updateInlineQuantityStates();
    }, 300);
    let attempts = 0;
    const checkInterval = setInterval(() => {
      const rows = document.querySelectorAll('table.qb-product-table tbody tr.qb-row');
      if (rows.length > 0) {
        clearInterval(checkInterval);
        updateInlineQuantityStates();
      }
      attempts++;
      if (attempts > 30) clearInterval(checkInterval);
    }, 200);
  }

  const observer = new MutationObserver(() => {
    setTimeout(updateInlineQuantityStates, 100);
  });
  
  const targetNode = document.getElementById('QuickBuySearchList');
  if (targetNode) {
    observer.observe(targetNode, { childList: true, subtree: true });
  }
  
  // Initialize immediately and also on DOMContentLoaded
  initQuantityButtonStates();
  initInlineHandlers();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuantityButtonStates);
  }
})();

/**
 * Quick Buy Discount Handlers
 * Applies discount preview based on selected button and persists selection.
 */
(function () {
  const STORAGE_KEY = 'quickBuyActiveDiscount';

  function getActiveDiscount() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch (e) {
      return null;
    }
  }

  function setActiveDiscount(level, value) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ level, value }));
    } catch (e) {
      // ignore storage errors
    }
  }

  function clearActiveDiscount() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      // ignore storage errors
    }
  }

  function updateButtonStates() {
    const activeDiscount = getActiveDiscount();
    document.querySelectorAll('.discount-button').forEach((btn) => {
      const level = btn.getAttribute('data-discount-level');
      if (activeDiscount && activeDiscount.level === level) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  function parsePriceString(rawValue) {
    if (!rawValue) return NaN;
    let cleaned = String(rawValue).trim().replace(/\s/g, '');
    cleaned = cleaned.replace(/[^0-9.,]/g, '');

    if (cleaned.includes(',')) {
      cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    }

    cleaned = cleaned.replace(/[^0-9.]/g, '');
    const parsed = parseFloat(cleaned);
    return Number.isNaN(parsed) ? NaN : parsed;
  }

  function clearDiscountDisplay() {
    document.querySelectorAll('table.qb-product-table tbody tr.qb-row').forEach((row) => {
      row.removeAttribute('data-qb-discount-preview');
      delete row._qbDiscountAnimToken;
    });
    document.querySelectorAll('#discountprice').forEach((col) => {
      col.innerHTML = '';
    });
  }

  const DISCOUNT_ANIM_MS = 520;

  function formatEuroDe(amount) {
    const n = typeof amount === 'number' && !Number.isNaN(amount) ? amount : 0;
    return `€${n.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  function easeOutCubic(t) {
    return 1 - (1 - t) ** 3;
  }

  /**
   * Animates the displayed euro amount from startAmount to endAmount (numeric EUR).
   */
  function animateDiscountPriceSpan(spanEl, startAmount, endAmount, animToken, row) {
    if (!spanEl) return;
    const start = Number(startAmount);
    const end = Number(endAmount);
    if (Number.isNaN(start) || Number.isNaN(end)) {
      spanEl.textContent = formatEuroDe(end);
      return;
    }
    const t0 = performance.now();

    function frame(now) {
      if (row && row._qbDiscountAnimToken !== animToken) return;
      const elapsed = now - t0;
      const u = Math.min(1, elapsed / DISCOUNT_ANIM_MS);
      const eased = easeOutCubic(u);
      const current = start + (end - start) * eased;
      spanEl.textContent = formatEuroDe(current);
      if (u < 1) {
        requestAnimationFrame(frame);
      } else {
        spanEl.textContent = formatEuroDe(end);
      }
    }
    requestAnimationFrame(frame);
  }

  function applyDiscountToRows(level, value) {
    const rows = document.querySelectorAll('table.qb-product-table tbody tr.qb-row');
    rows.forEach((row) => {
      const dataCompareAtPrice = row.getAttribute('data-compare-at-price');
      const dataNetPrice = row.getAttribute('data-net-price');

      if (!dataNetPrice) return;

      const rawPrice = parsePriceString(dataNetPrice);
      if (Number.isNaN(rawPrice)) return;

      const discountFactor = 1 - value / 100;
      const discountedPrice = rawPrice * discountFactor;
      const discountCol = row.querySelector('#discountprice');

      if (!discountCol) return;

      // Skip discount preview for promo-priced items
      if (dataCompareAtPrice) {
        discountCol.innerHTML = '';
        row.removeAttribute('data-qb-discount-preview');
        return;
      }

      const prevStored = row.getAttribute('data-qb-discount-preview');
      let startAmount = rawPrice;
      if (prevStored != null && prevStored !== '') {
        const p = parseFloat(prevStored, 10);
        if (!Number.isNaN(p)) startAmount = p;
      }

      row._qbDiscountAnimToken = (row._qbDiscountAnimToken || 0) + 1;
      const token = row._qbDiscountAnimToken;
      row.setAttribute('data-qb-discount-preview', String(discountedPrice));

      discountCol.innerHTML = `
        <div style="display: flex; align-items: center; gap: 8px; justify-content: center; flex-direction: column;">
          <span class="discount-indicator">${level}</span>
          <span class="qb-discount-price-value" data-qb-discount-amount>${formatEuroDe(startAmount)}</span>
        </div>
      `;

      const span = discountCol.querySelector('.qb-discount-price-value');
      animateDiscountPriceSpan(span, startAmount, discountedPrice, token, row);
    });
  }

  function waitForProductsToLoad(callback, maxAttempts = 10) {
    let attempts = 0;

    const checkProducts = () => {
      const rows = document.querySelectorAll('table.qb-product-table tbody tr.qb-row');
      if (rows.length === 0) {
        if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkProducts, 200);
        }
        return;
      }

      const hasData = Array.from(rows).some((row) => row.getAttribute('data-net-price'));
      if (hasData) {
        callback();
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(checkProducts, 200);
      }
    };

    checkProducts();
  }

  window.toggleDiscountQuickBuy = function (level, value) {
    const activeDiscount = getActiveDiscount();

    if (activeDiscount && activeDiscount.level === level) {
      clearActiveDiscount();
      clearDiscountDisplay();
      updateButtonStates();
      return;
    }

    setActiveDiscount(level, value);
    updateButtonStates();

    waitForProductsToLoad(() => {
      applyDiscountToRows(level, value);
    });
  };

  function autoApplyDiscount() {
    const activeDiscount = getActiveDiscount();
    updateButtonStates();

    if (activeDiscount) {
      waitForProductsToLoad(() => {
        applyDiscountToRows(activeDiscount.level, activeDiscount.value);
      });
    }
  }

  window.reapplyActiveDiscount = autoApplyDiscount;

  let discountTimeout = null;
  const observer = new MutationObserver((mutations) => {
    const hasChildListChanges = mutations.some(
      (m) => m.type === 'childList' && m.addedNodes.length > 0
    );
    if (!hasChildListChanges) return;

    clearTimeout(discountTimeout);
    discountTimeout = setTimeout(() => {
      const activeDiscount = getActiveDiscount();
      if (!activeDiscount) return;
      waitForProductsToLoad(() => {
        applyDiscountToRows(activeDiscount.level, activeDiscount.value);
      });
    }, 200);
  });

  const targetNode = document.getElementById('QuickBuySearchList');
  if (targetNode) {
    observer.observe(targetNode, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoApplyDiscount);
  } else {
    autoApplyDiscount();
  }
})();
